<template>
  <div>
    <GoodsSpecTable
      :orderGoodsCode="orderGoodsCode"
      :showDefaultImage="showDefaultImage"
    />
  </div>
</template>
<script>
import GoodsSpecTable from './components/table'
export default {
  components: { GoodsSpecTable },
  props: {
    orderGoodsCode: { type: String, default: '' },
    showDefaultImage: { type: Boolean, default: false },
  },
}
</script>
